import { hasPermissionAction } from "./organizationPermissions";

export const WALLET_ADMIN_ACTION = "WALLET_ADMIN_ALL";
export const WALLET_CLIENT_ROLE = "wallet client";
export const WALLET_AGENT_ROLE = "agent";

function resolveRoleName(userData) {
  return String(
    userData?.role_name ??
      userData?.role?.user_role_name ??
      userData?.role?.system_role_name ??
      userData?.user?.role_name ??
      ""
  )
    .trim()
    .toLowerCase();
}

/**
 * True when the signed-in user may use wallet admin UI/APIs.
 * Granted via Admin application role and/or WALLET_ADMIN_ALL permission.
 */
export function isWalletAdminUser(userData, permissions = []) {
  if (hasPermissionAction(permissions, WALLET_ADMIN_ACTION)) {
    return true;
  }

  return resolveRoleName(userData) === "admin";
}

/** True for portal users with the Wallet Client application role. */
export function isWalletClientUser(userData) {
  return resolveRoleName(userData) === WALLET_CLIENT_ROLE;
}

/** True for portal users with the Agent application role (single linked external application). */
export function isWalletAgentUser(userData) {
  return resolveRoleName(userData) === WALLET_AGENT_ROLE;
}

/** True when the user sees scoped wallet data (client or agent portal role). */
export function isWalletScopedUser(userData) {
  return isWalletClientUser(userData) || isWalletAgentUser(userData);
}

/** Wallet client id linked to the signed-in portal user, if any. */
export function resolveWalletClientId(userData) {
  const id =
    userData?.wallet_client_id ??
    userData?.wallet_client?.client_id ??
    userData?.wallet_client?.id ??
    userData?.wallet_agent?.client_id ??
    null;
  const parsed = Number(id);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

/** Linked external application id for Agent role users. */
export function resolveWalletAgentId(userData) {
  const id =
    userData?.wallet_agent_id ??
    userData?.wallet_agent?.external_application_id ??
    null;
  const parsed = Number(id);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

/** Wallet id for Agent role users when linked on login payload. */
export function resolveWalletAgentWalletId(userData) {
  const id = userData?.wallet_agent?.wallet_id ?? null;
  const parsed = Number(id);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}
